export { default as CombinedContacts } from './CombinedContacts';
